import type { SeedToken } from "ant-design-vue/es/theme/internal";
import type { ThemeConfig } from "ant-design-vue/es/config-provider/context";
import { BASE_THEME_SEED, getAntdComputedTokens } from "./tokens";

export const applyAntdTokensToCssVars = (
  seed: Partial<SeedToken> = BASE_THEME_SEED,
  algorithm?: ThemeConfig["algorithm"],
) => {
  const tokens = getAntdComputedTokens(seed, algorithm);
  const root = document.documentElement;

  Object.entries(tokens).forEach(([key, value]) => {
    if (typeof value === "string" || typeof value === "number") {
      root.style.setProperty(`--${kebabCase(key)}`, String(value));
    }
  });
};

const kebabCase = (str: string): string => {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};
